import { Observable } from 'rxjs'
import { first, flatMap, mergeMap } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'

import { AppState } from '../core.state'

import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class UserRoleHttpHeaderInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(
        first(),
        mergeMap((userRole) => {
          if (
            userRole &&
            typeof userRole?.id == 'number' &&
            request.url.includes(environment.backendApiUrl)
          ) {
            request = request.clone({
              setHeaders: {
                'x-user-role-id': userRole.id + ''
              }
            })
          }

          return next.handle(request)
        })
      )
  }
}
